export class Gender{
    /** The name. */
    name:string;
    /** The code */
    code:string;
}